import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

import { Fragment, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../../context/ToastContext';

import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';

import api from '../../../../api';

export default function EdicaoMassaProdutos() {
    const navigate = useNavigate();
    const { showToast } = useToast();

    const [carregando, setCarregando] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const [progresso, setProgresso] = useState({ atual: 0, total: 0 });
    const [produtos, setProdutos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [fornecedores, setFornecedores] = useState([]);

    const [expandidos, setExpandidos] = useState({});
    const [busca, setBusca] = useState('');

    const toggleExpandido = (id) => {
        setExpandidos((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const expandirTodos = () => {
        const todos = {};
        produtos.forEach((p) => { todos[p.id_produto] = true; });
        setExpandidos(todos);
    };

    const recolherTodos = () => {
        setExpandidos({});
    };

    useEffect(() => {
        const carregar = async () => {
            try {
                const [produtosRes, categoriasRes, fornecedoresRes] = await Promise.all([
                    api.get('/listarprodutosComVariacoes'),
                    api.get('/listarcategorias'),
                    api.get('/listarfornecedores')
                ]);

                const lista = produtosRes.data?.produtos || [];
                setCategorias(categoriasRes.data?.categorias || []);
                setFornecedores(fornecedoresRes.data?.fornecedores || []);

                const linhas = lista.map((produto) => {
                    const variacoes = (produto.variacoes || []).map((variacao) => ({
                        id_variacao: variacao.id,
                        imagensExistentes: variacao.imagens || [],
                        tamanho: variacao.tamanho || '',
                        cor: variacao.cor || '',
                        material: variacao.material || '',
                        tipo: variacao.tipo || '',
                        unidades_por_pacote: variacao.unidades_por_pacote ?? 1,
                        preco_compra: variacao.preco_compra ?? 0,
                        preco_varejo: variacao.preco_varejo ?? 0,
                        preco_atacado: variacao.preco_atacado ?? 0,
                        estoque: variacao.estoque ?? 0,
                        sku: variacao.sku || '',
                        peso: variacao.peso ?? 0,
                        altura: variacao.altura ?? 0,
                        largura: variacao.largura ?? 0,
                        profundidade: variacao.profundidade ?? 0
                    }));

                    return {
                        id_produto: produto.id_produto,
                        nome: produto.nome || '',
                        descricao: produto.descricao || '',
                        descricao_longa: produto.descricao_longa || '',
                        codigo_barras: produto.codigo_barras || '',
                        marca: produto.marca || '',
                        status: produto.status || 'ativo',
                        id_categoria: produto.id_categoria ? Number(produto.id_categoria) : 0,
                        id_fornecedor: produto.id_fornecedor ? Number(produto.id_fornecedor) : 0,
                        variacoes
                    };
                });

                setProdutos(linhas);
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
                showToast('Erro ao carregar produtos para edição em massa.', 'error');
            } finally {
                setCarregando(false);
            }
        };

        carregar();
    }, [showToast]);

    const atualizarProduto = (index, campo, valor) => {
        setProdutos((prev) => {
            const copia = [...prev];
            let valorFinal = valor;

            if (campo === 'id_categoria' || campo === 'id_fornecedor') {
                const valorNumerico = Number(valor);
                if (isNaN(valorNumerico)) return prev;
                valorFinal = valorNumerico;
            }

            copia[index] = { ...copia[index], [campo]: valorFinal };
            return copia;
        });
    };

    const atualizarVariacao = (produtoIndex, variacaoIndex, campo, valor) => {
        setProdutos((prev) => {
            const copia = [...prev];
            const variacoes = [...copia[produtoIndex].variacoes];
            variacoes[variacaoIndex] = { ...variacoes[variacaoIndex], [campo]: valor };
            copia[produtoIndex] = { ...copia[produtoIndex], variacoes };
            return copia;
        });
    };

    const montarPayloadVariacoes = (variacoes) => {
        return variacoes
            .filter((v) => v.id_variacao)
            .map((v) => ({
                id_variacao: v.id_variacao,
                tamanho: v.tamanho || '',
                cor: v.cor || '',
                material: v.material || '',
                tipo: v.tipo || '',
                unidades_por_pacote: Number(v.unidades_por_pacote) || 1,
                preco_compra: Number(v.preco_compra) || 0,
                preco_varejo: Number(v.preco_varejo) || 0,
                preco_atacado: Number(v.preco_atacado) || 0,
                estoque: Number(v.estoque) || 0,
                sku: v.sku || '',
                peso: Number(v.peso) || 0,
                altura: Number(v.altura) || 0,
                largura: Number(v.largura) || 0,
                profundidade: Number(v.profundidade) || 0,
                imagensExistentes: v.imagensExistentes || []
            }));
    };

    const validarProdutoParaSalvar = (produto, indice) => {
        const nome = (produto.nome || '').trim();
        const descricao = (produto.descricao || '').trim();
        const descricaoLonga = (produto.descricao_longa || '').trim();
        const codigoBarras = String(produto.codigo_barras || '').trim();
        const marca = (produto.marca || '').trim();
        const idCategoria = Number(produto.id_categoria) || 0;
        const idFornecedor = Number(produto.id_fornecedor) || 0;

        if (!nome || nome.length < 3 || nome.length > 100) {
            return `Produto ${indice + 1}: nome inválido.`;
        }
        if (!descricao || descricao.length > 250) {
            return `Produto ${indice + 1}: descrição inválida.`;
        }
        if (!descricaoLonga) {
            return `Produto ${indice + 1}: descrição longa obrigatória.`;
        }
        if (!codigoBarras || !/^\d+$/.test(codigoBarras) || ![8, 12, 13].includes(codigoBarras.length)) {
            return `Produto ${indice + 1}: código de barras inválido.`;
        }
        if (!marca || marca.length > 50) {
            return `Produto ${indice + 1}: marca inválida.`;
        }
        if (!['ativo', 'inativo'].includes((produto.status || '').toLowerCase())) {
            return `Produto ${indice + 1}: status inválido.`;
        }
        if (idCategoria <= 0 || Number.isNaN(idCategoria)) {
            return `Produto ${indice + 1}: categoria obrigatória.`;
        }
        if (idFornecedor <= 0 || Number.isNaN(idFornecedor)) {
            return `Produto ${indice + 1}: fornecedor obrigatório.`;
        }

        const variacoesValidas = montarPayloadVariacoes(produto.variacoes || []);
        if (!variacoesValidas.length) {
            return `Produto ${indice + 1}: sem variações válidas.`;
        }
        const variacaoSemSku = variacoesValidas.findIndex((v) => !v.sku || !String(v.sku).trim());
        if (variacaoSemSku >= 0) {
            return `Produto ${indice + 1}: SKU obrigatório na variação ${variacaoSemSku + 1}.`;
        }

        const variacaoSemImagem = variacoesValidas.findIndex((v) => !(v.imagensExistentes || []).length);
        if (variacaoSemImagem >= 0) {
            return `Produto ${indice + 1}: variação ${variacaoSemImagem + 1} sem imagem.`;
        }

        return '';
    };

    const salvarAlteracoes = async () => {
        if (!produtos.length) return;

        for (let idx = 0; idx < produtos.length; idx += 1) {
            const erro = validarProdutoParaSalvar(produtos[idx], idx);
            if (erro) {
                showToast(erro, 'error');
                return;
            }
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
        setSalvando(true);
        setProgresso({ atual: 0, total: produtos.length });

        try {
            for (let idx = 0; idx < produtos.length; idx += 1) {
                const produto = produtos[idx];
                const variacoesPayload = montarPayloadVariacoes(produto.variacoes);
                if (!variacoesPayload.length) {
                    showToast('Produto sem variações válidas para salvar.', 'error');
                    setSalvando(false);
                    return;
                }

                const formData = new FormData();
                const descricaoLonga = (produto.descricao_longa || '').trim() || (produto.descricao || '').trim();
                formData.append('nome', (produto.nome || '').trim());
                formData.append('descricao', (produto.descricao || '').trim());
                formData.append('descricao_longa', descricaoLonga);
                formData.append('codigo_barras', String(produto.codigo_barras || '').trim());
                formData.append('marca', (produto.marca || '').trim());
                formData.append('status', (produto.status || 'ativo').toLowerCase());
                formData.append('id_categoria', String(Number(produto.id_categoria) || 0));
                formData.append('id_fornecedor', String(Number(produto.id_fornecedor) || 0));
                formData.append('variacoes', JSON.stringify(variacoesPayload));

                await api.put(`/produtos/${produto.id_produto}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                setProgresso({ atual: idx + 1, total: produtos.length });
            }

            showToast('Edição em massa concluída com sucesso.', 'success');
            navigate('/menu/produtos_e_estoque');
        } catch (error) {
            console.error('Erro ao salvar edição em massa:', error);
            const response = error.response?.data;
            const errors = Array.isArray(response?.errors) ? response.errors.join(' ') : '';
            const mensagem = response?.message || response?.error || errors || 'Erro ao salvar edição em massa.';
            showToast(mensagem, 'error');
        } finally {
            setSalvando(false);
        }
    };

    const produtosFiltrados = useMemo(() => {
        if (!busca.trim()) return produtos.map((p, i) => ({ ...p, _originalIndex: i }));
        const termo = busca.toLowerCase();
        return produtos
            .map((p, i) => ({ ...p, _originalIndex: i }))
            .filter((p) =>
                p.nome.toLowerCase().includes(termo) ||
                p.marca.toLowerCase().includes(termo) ||
                p.codigo_barras.includes(termo)
            );
    }, [produtos, busca]);

    return (
        <section className='container-principal-edicao-massa'>
            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className='conteudo-edicao-massa'>
                    <div className='header-edicao-massa'>
                        <div className='header-info'>
                            <h1>Edição em Massa</h1>
                            <p>Edite produtos e variações de forma rápida e organizada.</p>
                        </div>
                        <div className='header-acoes'>
                            <div className='busca-wrapper'>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M14 14L11.1 11.1" stroke="#999" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Buscar por nome, marca ou código..."
                                    value={busca}
                                    onChange={(e) => setBusca(e.target.value)}
                                />
                            </div>
                            <div className='btns-expandir'>
                                <button className='btn-expandir' onClick={expandirTodos} title="Expandir todos">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Expandir
                                </button>
                                <button className='btn-expandir' onClick={recolherTodos} title="Recolher todos">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 10L8 6L12 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Recolher
                                </button>
                            </div>
                        </div>
                    </div>
                    <BtnVoltar />

                    {carregando ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando produtos...</h2>
                        </div>
                    ) : (
                        <div className='lista-produtos-massa'>
                            <p className='contador-produtos'>{produtosFiltrados.length} produto(s) encontrado(s)</p>

                            {produtosFiltrados.map((produto) => {
                                const idx = produto._originalIndex;
                                const isOpen = expandidos[produto.id_produto];
                                const variacoesAtivas = produto.variacoes;

                                return (
                                    <div className={`card-produto-massa ${isOpen ? 'aberto' : ''}`} key={produto.id_produto}>
                                        <div className='card-header' onClick={() => toggleExpandido(produto.id_produto)}>
                                            <div className='card-header-info'>
                                                <span className={`status-badge ${produto.status}`}>{produto.status}</span>
                                                <h3>{produto.nome || 'Sem nome'}</h3>
                                                <span className='meta-info'>
                                                    {variacoesAtivas.length} variação(ões) · {produto.marca || '—'}
                                                </span>
                                            </div>
                                            <svg className={`chevron ${isOpen ? 'open' : ''}`} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>

                                        {isOpen && (
                                            <div className='card-body'>
                                                <div className='secao-produto'>
                                                    <h4 className='secao-titulo'>Informações do Produto</h4>
                                                    <div className='grid-campos'>
                                                        <div className='campo'>
                                                            <label>Nome</label>
                                                            <input
                                                                type='text'
                                                                value={produto.nome}
                                                                onChange={(e) => atualizarProduto(idx, 'nome', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Marca</label>
                                                            <input
                                                                type='text'
                                                                value={produto.marca}
                                                                onChange={(e) => atualizarProduto(idx, 'marca', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Código de Barras</label>
                                                            <input
                                                                type='text'
                                                                value={produto.codigo_barras}
                                                                onChange={(e) => atualizarProduto(idx, 'codigo_barras', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Status</label>
                                                            <select
                                                                value={produto.status}
                                                                onChange={(e) => atualizarProduto(idx, 'status', e.target.value)}
                                                            >
                                                                <option value='ativo'>Ativo</option>
                                                                <option value='inativo'>Inativo</option>
                                                            </select>
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Categoria</label>
                                                            <select
                                                                value={produto.id_categoria || 0}
                                                                onChange={(e) => atualizarProduto(idx, 'id_categoria', e.target.value)}
                                                                className={Number(produto.id_categoria) <= 0 ? 'campo-erro' : ''}
                                                            >
                                                                <option value={0}>Selecione...</option>
                                                                {categorias.map((cat) => (
                                                                    <option key={cat.id_categoria} value={cat.id_categoria}>
                                                                        {cat.nome}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='campo'>
                                                            <label>Fornecedor</label>
                                                            <select
                                                                value={produto.id_fornecedor || 0}
                                                                onChange={(e) => atualizarProduto(idx, 'id_fornecedor', e.target.value)}
                                                                className={Number(produto.id_fornecedor) <= 0 ? 'campo-erro' : ''}
                                                            >
                                                                <option value={0}>Selecione...</option>
                                                                {fornecedores.map((forn) => (
                                                                    <option key={forn.id} value={forn.id}>
                                                                        {forn.nome}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='campo campo-largo'>
                                                            <label>Descrição</label>
                                                            <textarea
                                                                rows={2}
                                                                value={produto.descricao}
                                                                onChange={(e) => atualizarProduto(idx, 'descricao', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='campo campo-largo'>
                                                            <label>Descrição Longa</label>
                                                            <textarea
                                                                rows={3}
                                                                value={produto.descricao_longa}
                                                                onChange={(e) => atualizarProduto(idx, 'descricao_longa', e.target.value)}
                                                            />
                                                            <small className='descricao-longa-hint'>Quebra de linha, emojis e HTML simples são suportados (color e font-size no style).</small>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='secao-variacoes'>
                                                    <h4 className='secao-titulo'>Variações</h4>
                                                    {produto.variacoes.map((variacao, vi) => (
                                                            <div className='variacao-card' key={vi}>
                                                                <div className='variacao-header'>
                                                                    <span className='variacao-numero'>#{vi + 1}</span>
                                                                    <span className='variacao-sku'>{variacao.sku || 'Sem SKU'}</span>
                                                                    {variacao.imagensExistentes?.length > 0 && (
                                                                        <img
                                                                            src={variacao.imagensExistentes[0]?.url || variacao.imagensExistentes[0]}
                                                                            alt={`Var ${vi + 1}`}
                                                                            className='variacao-thumb'
                                                                        />
                                                                    )}
                                                                </div>
                                                                <div className='variacao-grid'>
                                                                    <div className='campo-mini'>
                                                                        <label>Tamanho</label>
                                                                        <input type='text' value={variacao.tamanho} onChange={(e) => atualizarVariacao(idx, vi, 'tamanho', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Cor</label>
                                                                        <input type='text' value={variacao.cor} onChange={(e) => atualizarVariacao(idx, vi, 'cor', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Material</label>
                                                                        <input type='text' value={variacao.material} onChange={(e) => atualizarVariacao(idx, vi, 'material', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Tipo</label>
                                                                        <input type='text' value={variacao.tipo} onChange={(e) => atualizarVariacao(idx, vi, 'tipo', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Unid/Pacote</label>
                                                                        <input type='number' value={variacao.unidades_por_pacote} onChange={(e) => atualizarVariacao(idx, vi, 'unidades_por_pacote', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>SKU</label>
                                                                        <input type='text' value={variacao.sku} onChange={(e) => atualizarVariacao(idx, vi, 'sku', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini destaque-preco'>
                                                                        <label>P. Compra</label>
                                                                        <input type='number' value={variacao.preco_compra} onChange={(e) => atualizarVariacao(idx, vi, 'preco_compra', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini destaque-preco'>
                                                                        <label>P. Varejo</label>
                                                                        <input type='number' value={variacao.preco_varejo} onChange={(e) => atualizarVariacao(idx, vi, 'preco_varejo', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini destaque-preco'>
                                                                        <label>P. Atacado</label>
                                                                        <input type='number' value={variacao.preco_atacado} onChange={(e) => atualizarVariacao(idx, vi, 'preco_atacado', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini destaque-estoque'>
                                                                        <label>Estoque</label>
                                                                        <input type='number' value={variacao.estoque} onChange={(e) => atualizarVariacao(idx, vi, 'estoque', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Peso (kg)</label>
                                                                        <input type='number' value={variacao.peso} onChange={(e) => atualizarVariacao(idx, vi, 'peso', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Altura (cm)</label>
                                                                        <input type='number' value={variacao.altura} onChange={(e) => atualizarVariacao(idx, vi, 'altura', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Largura (cm)</label>
                                                                        <input type='number' value={variacao.largura} onChange={(e) => atualizarVariacao(idx, vi, 'largura', e.target.value)} />
                                                                    </div>
                                                                    <div className='campo-mini'>
                                                                        <label>Profund. (cm)</label>
                                                                        <input type='number' value={variacao.profundidade} onChange={(e) => atualizarVariacao(idx, vi, 'profundidade', e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {!carregando && (
                        <div className='barra-salvar-fixa'>
                            {salvando && (
                                <div className='progresso-barra'>
                                    <div className='progresso-fill' style={{ width: `${(progresso.atual / progresso.total) * 100}%` }}></div>
                                </div>
                            )}
                            <div className='barra-salvar-conteudo'>
                                <span className='info-salvar'>
                                    {salvando
                                        ? `Salvando ${progresso.atual} de ${progresso.total}...`
                                        : `${produtos.length} produto(s) serão salvos`
                                    }
                                </span>
                                <button className='btn-salvar-massa' onClick={salvarAlteracoes} disabled={salvando || carregando}>
                                    {salvando ? (
                                        <>
                                            <div className='spinner-btn'></div>
                                            Salvando...
                                        </>
                                    ) : (
                                        <>
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H12L15.75 6V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M12.75 15.75V9.75H5.25V15.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M5.25 2.25V6H11.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            Salvar Alterações
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
